import {AfterViewInit, Component, Input, OnDestroy, OnInit, ElementRef, Renderer2} from '@angular/core';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {User} from '@models/user';
import {MatDialog} from '@node_modules/@angular/material';
import {Subscription} from '@models/subscription';
import {UpdateAuthUser} from '@store/auth/actions';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {SubscriptionService} from '@services/subscription/subscription.service';
import {BehaviorSubject} from '@node_modules/rxjs/internal/BehaviorSubject';
import {Subject} from '@node_modules/rxjs/internal/Subject';
import * as SubscriptionReducer from '@store/subscription/reducers';
import {ActivatedRoute, Router} from '@node_modules/@angular/router';
import {CreateProgramSubscriptionComponent} from '@pages/layout/program/program-page/program-payment/create-program-subscription/create-program-subscription.component';
import {ScenarioAddComponent} from '@pages/layout/subscription/scenario/scenario-add/scenario-add.component';
import {ScenarioEditComponent} from '@pages/layout/subscription/scenario/scenario-edit/scenario-edit.component';

@Component({
  selector: 'app-scenario-page',
  templateUrl: './scenario-page.component.html',
  styleUrls: ['./scenario-page.component.scss']
})
export class ScenarioPageComponent implements OnInit, OnDestroy {
  @Input() user: User;
  @Input() usersSubject: Subject<User>;
  subscribes = [];
  // scenarios: BehaviorSubject<Subscription[]> = new BehaviorSubject([]);
  scenarios: {
      name: string;
      who_pays: string;
      school_plan: string;
      student_plan: string;
  }[] = [];
  subscriptionsFilter: any[];
  viewDialog;
  confirmStopDialog;
  confirmSubscribeDialog;
  confirmDialog;
  createDialog;
  editDialog;
  isDarkTheme = false;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private subscriptionService: SubscriptionService,
    private authStore: Store<AuthReducer.AuthState>,
    private subscribtionStore: Store<SubscriptionReducer.SubscriptionState>,
  ) {

  }

  ngOnInit() {
    this.isDarkTheme = localStorage.getItem('mkc-dashboard-theme') === 'dark';
    this.applyTheme();

    this.loadScenarios();

  }

  ngOnDestroy() {
    this.subscribes.map( subscr => subscr.unsubscribe());
  }

  openCreateModalAction(){
    this.createDialog = this.dialog.open(ScenarioAddComponent, {
      disableClose: true,
      autoFocus: false,
      panelClass: 'mkc-scenario-create-dialog',
    });
    this.createDialog.afterClosed().subscribe(result => {
      if (result) {
        this.loadScenarios();
      }
    });
  }

  openViewModal(event, subscription: Subscription) {
    if (!event.target.classList.contains('buttons-bottom-continue')) {
      CreateProgramSubscriptionComponent.allSubscriptions = [];
      CreateProgramSubscriptionComponent.source = 'view';
      CreateProgramSubscriptionComponent.sourceEdit = subscription;
      this.viewDialog = this.dialog.open(CreateProgramSubscriptionComponent);
      CreateProgramSubscriptionComponent.modalRef = this.viewDialog;
      this.viewDialog.afterClosed().subscribe(result => {
        this.viewDialog.close();
      });
    }
  }

  openDeleteModal(sub) {
    ConfirmModalComponent.insertedObject = this;
    ConfirmModalComponent.textModal = 'Are you sure that you want to delete this?';
    ConfirmModalComponent.methodDelete = 'actionDelete';
    ConfirmModalComponent.methodDeleteParam = sub;
    this.confirmDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmDialog;
    this.confirmDialog.afterClosed().subscribe(result => {
      this.confirmDialog.close();
    });
  }

  actionDelete(sub) {
    this.subscriptionService.removeScenario({id: sub.id}).subscribe(
      (resp: {data: any}) => {
        this.subscriptionService.getAllScenario().subscribe(
          (resp: {data: any}) => {
            this.scenarios = resp.data;
          }
        );
      }
    );
  }

  openEdit(member){
    this.editDialog = this.dialog.open(ScenarioEditComponent, {
      disableClose: true,
      autoFocus: false,
      panelClass: 'mkc-scenario-edit-dialog',
      data: {
        scenarioId: member.id
      }
    });
    this.editDialog.afterClosed().subscribe(result => {
      if (result) {
        this.loadScenarios();
      }
    });
  }

  setTheme(theme: 'light' | 'dark') {
    this.isDarkTheme = theme === 'dark';
    localStorage.setItem('mkc-dashboard-theme', theme);
    this.applyTheme();
  }

  private applyTheme() {
    const shell = document.getElementById('page-wrapper');
    if (shell) {
      shell.classList.toggle('theme-dark', this.isDarkTheme);
    }
    document.documentElement.classList.add('mkc-dashboard-shell');
    document.body.classList.add('mkc-dashboard-shell');
    document.documentElement.classList.toggle('mkc-theme-dark', this.isDarkTheme);
    document.body.classList.toggle('mkc-theme-dark', this.isDarkTheme);
  }

  private loadScenarios() {
    this.subscriptionService.getAllScenario().subscribe(
      (resp: {data: any}) => {
        console.log(resp);
        this.scenarios = resp.data;
      }
    );
  }

}
